// extracted by css-extract-rspack-plugin
export default {"downloadhero":"LoginModal-downloadhero_8P0"};